import React, { FC } from 'react';
import { SvgProps } from 'react-native-svg';
import { View, Pressable, ViewStyle, Linking } from 'react-native';
import { Link } from '@react-navigation/native';

import CustomText from '@atoms/CustomText';
import { useMyProfile } from '@services/useMyProfile';
import DownArrow from '@assets/svg/DownArrow';
import Search from '@atoms/Search';
import { AvatarProfile } from '@atoms/AvatarProfile';
import Button from '@atoms/Button';
import handleAnalyticsEvent from '@utils/analytics';
import { AnalyticsEvents } from '@constants/analyticsEvents';
import { useStore, authTokenSelector } from '@store/index';
import { Colors } from '@theme';
import { useTranslations } from '@hooks/useTranslation';
import { useUploadingGameLink } from '@hooks/useUploadingGameLink';

import { styles } from '../styles';
import LoginButton from '../LoginButton/LoginButton';
import { NotificationsButton } from '../NotificationButton/NotificationButton';

interface NavbarLinkButtonProp {
  to: string;
  currentPath?: string;
  children: React.ReactNode;
  icon?: FC<SvgProps>;
  style?: ViewStyle;
}

const NavbarLinkButton = ({ to, style, currentPath, children, icon }: NavbarLinkButtonProp) => {
  const isActive = currentPath === to;
  const iconProps = { fill: isActive ? Colors.limeGreen : Colors.white };
  const Icon = icon;
  return (
    <Link to={to} style={[styles.linkButton, style]}>
      {Icon ? Icon(iconProps) : null}
      <CustomText
        weight="interSemi"
        size="xmedium"
        customStyle={styles.buttonText}
        numberOfLines={1}
        color={isActive ? 'limeGreen' : undefined}>
        {children}
      </CustomText>
    </Link>
  );
};

interface DesktopTopbarProps {
  route: string;
  handleUserMenuToggle: () => void;
}

const DesktopTopbar = ({ route, handleUserMenuToggle }: DesktopTopbarProps) => {
  const currentPath = route?.split('?')[0];
  const { data: userProfile } = useMyProfile();
  const authToken = useStore(authTokenSelector);
  const i18n = useTranslations();
  const link = useUploadingGameLink();

  const handleUploadGame = () => {
    handleAnalyticsEvent(AnalyticsEvents.UPLOAD_GAME_BANNER);
    Linking.openURL(link);
  };

  return (
    <>
      <View style={styles.search}>
        <Search />
      </View>

      <NavbarLinkButton to="/explore" style={styles.btnSecondary} currentPath={currentPath}>
        {i18n.t('desktop_navbar.explore_games')}
      </NavbarLinkButton>

      <Button onPress={handleUploadGame} customStyle={styles.leftGap} customTextStyle={styles.buttonText}>
        {i18n.t('desktop_navbar.upload_game')}
      </Button>
      {!authToken ? (
        <LoginButton />
      ) : (
        <>
          <NotificationsButton />
          <Pressable hitSlop={20} style={styles.userButton} onPress={() => handleUserMenuToggle()}>
            <AvatarProfile
              customContainerStyle={styles.avatar}
              imageUrl={userProfile?.profileImage || ''}
              backgroundUrl={userProfile?.backgroundProfileImage || ''}
              offsetKitten={2}
            />
            <DownArrow />
          </Pressable>
        </>
      )}
    </>
  );
};

export default DesktopTopbar;
